import React, { useState } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Image from 'react-bootstrap/Image';
import checklistCSS from './checklist.module.css';
import writtenLogo from '../../images/skriftlig-logo.png';
import logoImg from '../../images/Logo.png';
import underskrift from '../../images/underskrift.png';

function ChecklistModal({ buttonTitle, modalTitle, serviceChecks, openButtonClass, product, customer, serviceInfo, closeButtonClass, serial, comment }) {
  const [show, setShow] = useState(false);
  const performedBy = serviceInfo.performed_by.data.attributes.username;
  const datePerformed = serviceInfo.date_performed;

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const downloadPDF = () => {
    const capture = document.querySelector('.to-pdf');
    html2canvas(capture).then((canvas) => {
      const imgData = canvas.toDataURL('img/png');
      const doc = new jsPDF('p', 'mm', 'a4');
      const componentWidth = doc.internal.pageSize.getWidth();
      const componentHeight = doc.internal.pageSize.getHeight();
      doc.addImage(imgData, 'PNG', 0, 0, componentWidth, componentHeight);
      doc.save('Sjekkliste.pdf');
    });
  };

  return (
    <>
      <Button className={openButtonClass} variant="primary" onClick={handleShow}>
        {buttonTitle}
      </Button>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="to-pdf">
            <div className={checklistCSS.filler}></div>
            <div className={checklistCSS.container1}>
              <div className={checklistCSS.topRow}>
                <div className={checklistCSS.hDiv}>
                    <div className={checklistCSS.h1}>SERVICERAPPORT</div>
                    <div className={checklistCSS.h2}>{product.name}</div>
                </div>
                <div className={checklistCSS.vp}>
                  <div className={checklistCSS.logo}>
                    <div className={checklistCSS.logoImg}>
                      <Image fluid alt="vp-logo" src={logoImg} />
                    </div>
                    <div className={checklistCSS.writtenLogo}>
                      <Image fluid alt="vp-logo" src={writtenLogo} />
                    </div>
                  </div>
                  <div className={checklistCSS.vpInfo}>
                    <p>Org.nr: 948 636 778</p>
                    <p>Tuenveien 80, 2000 Lillestrøm</p>
                    <p>ab@verktoypartner.no</p>
                  </div>
                </div>
              </div>
              <div className={checklistCSS.container3}>
                <div className={checklistCSS.infoContainer}>
                    <div className={checklistCSS.info}>
                        <div className={checklistCSS.static}>Kundenavn:</div>
                        <div className={checklistCSS.dynamic}>{customer.username}</div>
                    </div>
                    <div className={checklistCSS.info2}>
                        <div className={checklistCSS.static}>Dato:</div>
                        <div className={checklistCSS.dynamic}>{datePerformed}</div>
                    </div>
                </div>
                <div className={checklistCSS.infoContainer2}>
                    <div className={checklistCSS.info}>
                        <div className={checklistCSS.static}>Serienummer:</div>
                        <div className={checklistCSS.dynamic}>{serial}</div>
                    </div>
                    <div className={checklistCSS.info2}>
                        <div className={checklistCSS.static}>Utført av:</div>
                        <div className={checklistCSS.dynamic}>{performedBy}</div>
                    </div>
                </div>
                <div className={checklistCSS.p2}>
                  TESTPUNKTER
                </div>
              </div>
              <div className={checklistCSS.container4}>
              <Table striped bordered hover>
                  <thead>
                      <tr>
                          <th>Sjekk</th>
                          <th>Beskrivelse</th>
                          <th style={{ width:'15%', textAlign: 'center' }}>Utført</th>
                      </tr>
                  </thead>
                  <tbody>
                      {serviceChecks.map((check, index) => (
                          <tr key={index} className={checklistCSS.checkItem}>
                              <td>{index + 1}</td>
                              <td>{check.attributes.description}</td>
                              <td style={{ textAlign: 'center' }}>GODKJENT</td>
                          </tr>
                      ))}
                  </tbody>
              </Table>
                <div className={checklistCSS.static}>Kommentar:</div>
                <div className={checklistCSS.dynamic}>{comment}</div>
                <div className={checklistCSS.ansvar}>Jeg bekrefter at jeg er autorisert til å signere for bedriften og at arbeidet er utført iht. serviceavtale/forespørsel.
                    Sjekklisten er sett igjennom og jeg har mottatt kopi av denne.</div>
              </div>
              <div className={checklistCSS.container5}>
                <div className={checklistCSS.signatur}>
                  <Image fluid alt="underskrift" src={underskrift} />
                </div>
                <p className={checklistCSS.p5}>SERVICEANSVARLIG</p>
              </div>
            </div>
            <div className={checklistCSS.filler}></div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className={checklistCSS.downloadButton} onClick={downloadPDF}>Last ned</Button>
          <Button className={closeButtonClass} variant="primary" onClick={handleClose}>
            Lukk
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ChecklistModal;